import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	tipLabel: {
		id: 'polaris-components-quickstart.components.task-description-tip.label',
		defaultMessage: 'Tip:',
		description: 'Label for the tip section',
	},
});
